<div class="lightBorder padding10 singleLine" style="width: 100%;">
  <span (click)="clickShorting()">{{header}}</span>
  <ion-icon *ngIf="sortingVariable" [name]="sortingDirection ? 'arrow-up-outline' : 'arrow-down-outline'"></ion-icon>
  <!-- <span > -->
  <!-- <ion-badge color="secondary" mode="ios" *ngFor="let item of filterList">
    <span *ngIf="item[0]==variable">{{item[1]}}</span></ion-badge> -->
  <!-- </span> -->
  <!-- <ion-icon (click)="clickFilter()" class="floatRight" name="funnel" *ngIf="!searchable"></ion-icon>
  <ion-icon (click)="clickFilter()" class="floatRight" name="search" *ngIf="searchable"></ion-icon> -->
</div>